export const sliderGalleryV2 = {
  elements: Array.from(
    document.querySelectorAll(".slider-gallery-v2 .swiper-container")
  ),
  details: (el) => ({
    // Optional parameters
    // cssMode: true,
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 0,
    threshold: 10,
    centeredSlides: false, // Centra le slide
    centerInsufficientSlides: true, // Centra le slide se non riempiono lo slider
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    speed: 2000,
    freeMode: false,
    // longSwipesRatio: 2,
    resistance: false,

    // Disable preloading of all images
    // preloadImages: false,
    // Enable lazy loading
    lazy: true,

    // If we need pagination
    pagination: {
      el: el.querySelector(".swiper-pagination"),
    },
    // Navigation arrows
    navigation: {
      nextEl: el.querySelector(".swiper-button-next"),
      prevEl: el.querySelector(".swiper-button-prev"),
    },
    // breakpoints: {
    //   1023: {
    //     slidesPerView: 4,
    //     spaceBetween: 20,
    //   },
    //   640: {
    //     slidesPerView: 3,
    //     spaceBetween: 20,
    //   },
    // },
  }),
};
